import { LoaderSpinner } from '../../../../components/stories/Loader'
import { getReportBuilderPDF, useCustomReport } from '../../../../api'
import { useModuleCopy } from '../../../../context'
import { ReportPreviewItems } from './ReportPreviewItems'

export const CustomReportView = ({ reportId = null }) => (
  <div className='content-blocks'>{reportId ? <CustomReportPreview reportId={reportId} /> : <CustomReportPreviewPlaceholder />}</div>
)

export const CustomReportPreview = ({ reportId }) => {
  const { data, isLoading } = useCustomReport({ id: reportId })

  const { content: items, name: title } = data ?? {} // Empty on error

  return <CustomReportPreviewContent items={items} title={title} loading={isLoading} />
}

export const LiveCustomReportView = ({ report }) => (
  <div className='content-blocks'>
    {report.content.length > 0 ? <CustomReportPreviewContent title={report.name} items={report.content} loading={false} /> : <CustomReportPreviewPlaceholder />}
  </div>
)

export const CustomReportPreviewPlaceholder = () => {
  return (
    <div className='preview center'>
      <div>
        <h2>Preview</h2>
        <p>Once you select options from the left, a preview will show here</p>
      </div>
    </div>
  )
}

export const CustomReportPreviewContent = ({ title = '', items = [], loading }) => {
  const { textCopy } = useModuleCopy()

  const handleExport = () => {
    getReportBuilderPDF(items, {
      labels: {
        criteria: textCopy.criteria.label
      }
    })
  }

  const showActionButtons = !loading && items.length > 0

  return (
    <>
      <div className='title'>
        <h3>Preview</h3>
        <h2>{title}</h2>
        {showActionButtons && (
          <div className='action-buttons'>
            <button onClick={handleExport}>Export to PDF</button>
          </div>
        )}
      </div>
      <div className='preview'>{loading ? <LoaderSpinner /> : <ReportPreviewItems items={items} />}</div>
    </>
  )
}
